import React from "react";
import { useTranslation } from "react-i18next";
import logo from "../../assets/images/logo_sm.svg";
const SuspendedAccountView = (): JSX.Element => {
  const { t } = useTranslation("common");
  return (
    <div className="preloader-page">
      <div className={`center suspend ${true ? "" : "desktop"}`}>
        <img src={logo} width={167} height={112} alt="" />
        <div className="suspend-text">
          <h2>{t("state.blockedHeader")}</h2>
          <h5>{t("state.blockedExpl")}</h5>
        </div>
      </div>
    </div>
  );
};

export default React.memo(SuspendedAccountView);
